import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Select,
  FormControl,
  FormLabel,
  Text,
  Spinner,
  Box,
} from "@chakra-ui/react";
import emailTemplateService from "services/Recruit/services/emailTemplate";

const RejectionEmailModal = ({ isOpen, onClose, onSend, isLoading }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [loadingTemplates, setLoadingTemplates] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTemplates();
      setSelectedTemplate("");
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isLoading && !isOpen) {
      setSelectedTemplate("");
    }
  }, [isLoading, isOpen]);

  const fetchTemplates = async () => {
    setLoadingTemplates(true);
    try {
      const response = await emailTemplateService.getTemplates({
        allData: true,
        isActive: true
      });
      const allTemplates = response?.data || [];
      // Only show templates with application category
      setTemplates(allTemplates.filter(t => t.category === 'application'));
    } catch (error) {
      console.error("Failed to fetch email templates:", error);
    } finally {
      setLoadingTemplates(false);
    }
  };

  const handleSendClick = () => {
    if (selectedTemplate) {
      onSend(selectedTemplate);
    }
  };

  const handleConfirmSend = () => {
    onSend(selectedTemplate);
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Rejection Email</ModalHeader>
        <ModalCloseButton isDisabled={isLoading} />
        <ModalBody>
          {loadingTemplates ? (
            <Box display="flex" justifyContent="center" py={4}>
              <Spinner />
            </Box>
          ) : templates.length === 0 ? (
            <Text color="gray.500">
              No email templates available. Please create an email template first.
            </Text>
          ) : (
            <FormControl>
              <FormLabel>Email Template</FormLabel>
              <Select
                placeholder="Select an email template"
                value={selectedTemplate}
                onChange={(e) => setSelectedTemplate(e.target.value)}
                isDisabled={isLoading}
              >
                {templates.map((template) => (
                  <option key={template._id} value={template._id}>
                    {template.name} ({template.category || "custom"})
                  </option>
                ))}
              </Select>
            </FormControl>
          )}
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose} isDisabled={isLoading}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSendClick}
            isLoading={isLoading}
            isDisabled={!selectedTemplate || isLoading || loadingTemplates}
          >
            Send Email
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RejectionEmailModal;
